export default {
  app_bar: {
    title: "ระบบรายงานตัวออนไลน์ / สจล.1",
    homepage: "หน้าหลัก",
    login: "เข้าสู่ระบบ",
    logout: "ออกจากระบบ",
    undergraduate: "ระดับปริญญาตรี",
    graduate: "ระดับบัณฑิตศึกษา",
    info: "สิ่งที่ควรทราบ ระดับปริญญาตรี",
    info_graduate: "สิ่งที่ควรทราบ ระดับบัณฑิตศึกษา",
    list: "รายชื่อ ระดับปริญญาตรี",
    list_graduate: "รายชื่อ ระดับบัณฑิตศึกษา",
    university_name: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
    main: "รายงานตัว",
    questionnaire: "แบบสอบถาม",
    manual_student: "คู่มือการใช้งานระบบรายงานตัว",
    manual_officer: "คู่มือการใช้งาน สำหรับเจ้าหน้าที่",
  },
  drawer: {
    main_menu: 'เมนูหลัก',
    matriculation_system: 'ระบบรายงานตัว',
    user_account: 'บัญชีผู้ใช้งาน',
    personnel_record: 'ทะเบียนประวัติ',
    officer: "ตรวจรายงานตัว",
    manual: 'คู่มือการใช้งาน',
    user_management: 'การจัดการผู้ใช้งาน',
    config: 'การตั้งค่า',
  },
  landing: {
    system: "ระบบรายงานตัวออนไลน์ / สจล.1",
    undergraduate: "ระดับปริญญาตรี",
    graduate: "ระดับบัณฑิตศึกษา",
    info: "สิ่งที่ควรทราบ",
    document: "เอกสารดาวน์โหลด",
    list: "รายชื่อ",
  },
  kmitl1: {
    title: "สจล.1",
    not_complete: "ยังรายงานตัวไม่สำเร็จ",
  },
  info: {
    system: "ระบบรายงานตัวออนไลน์ / สจล.1",
    admityear: "ปีการศึกษา",
    undergraduate: "ระดับปริญญาตรี",
    graduate: "ระดับบัณฑิตศึกษา",
    maininfo: "สิ่งที่ควรทราบ / แบบฟอร์มเอกสาร",
    info: "สิ่งที่ควรทราบ",
    documentform: "แบบฟอร์มเอกสาร",
    document: "เอกสาร",
    form: "แบบฟอร์ม",
    select: "สามารถเลือกใช้เวอร์ชันใดเวอร์ชันหนึ่งเท่านั้น",
    version_th: "เวอร์ชันภาษาไทย",
    version_en: "English Version",
    form1: "เอกสารและขั้นตอนรายงานตัว",
    form2: "ข้อปฎิบัตินักศึกษาใหม่",
    form3: "ปฎิทินการศึกษา",
    form4: "รายละเอียดรูปถ่ายผู้รายงานตัว",
    doc1: "แบบฟอร์มยินยอมให้ใช้และเปิดเผยข้อมูล",
    doc2: "แบบฟอร์มยืนยันการรายงานตัว-และรับรองความถูกต้องของข้อมูล	",
    doc3: "แบบฟอร์มการส่งเอกสารและการรายงานตัวระดับบัณฑิตศึกษาและการผ่านเกณฑ์ภาษาอังกฤษ",
    doc4: "แบบฟอร์มขอส่งเอกสารล่าช้า (สำหรับผู้ที่ยังไม่มีทรานสคริปต์ฉบับสมบูรณ์ เท่านั้น)",
    have_not_fill_page_before: "*ยังไม่ได้บันทึกข้อมูลหน้าก่อนหน้า",
    open: "เปิดระบบรายงานตัวออนไลน์ เวลา 8.30 น. ของวันแรกในวันที่กำหนดแต่ละรอบ",
    close: "ปิดระบบรายงานตัวออนไลน์ เวลา 16.00 น. ของวันสุดท้ายในวันที่กำหนดแต่ละรอบ",
    ungrad_recommendation: "ข้อแนะนำการรายงานตัวเป็นนักศึกษาระดับปริญญาตรี << คลิก >>",
  },
  list: {
    system: "ระบบรายงานตัวออนไลน์ / สจล.1",
    admityear: "ปีการศึกษา",
    undergraduate: "ระดับปริญญาตรี",
    graduate: "ระดับบัณฑิตศึกษา",
    prestudent_list: "รายชื่อผู้มีสิทธิ์รายงานตัว",
    faculty: "เลือกคณะ / วิทยาลัย",
    curriculum: "เลือกหลักสูตร / สาขา",
    search: "ค้นหา (เลขที่ผู้สมัคร, รหัสนักศึกษา, ชื่อ)",
    apply_number: "เลขที่ผู้สมัคร",
    student_id: "รหัสนักศึกษา",
    name: "ชื่อ",
    surname: "นามสกุล",
    status: "สถานะ",
    validate: "ตรวจสอบ",
  },
  login: {
    prestudent_authen_title: "ยืนยันตัวตนด้วย 'เลขที่ใบสมัคร' และ 'รหัสผ่าน'",
    prestudent_authen_text: "โดยใช้บัญชีผู้ใช้งานระบบรับสมัครนักศึกษา",
    officer_student_authen: "เข้าสู่ระบบสำหรับเจ้าหน้าที่ / อาจารย์ / นักศึกษาปัจจุบัน",
    google_authen_title: "ยืนยันตัวตนด้วยบริการของ Google",
    google_authen_text: "โดยใช้อีเมลของสถาบันฯ",
    university_authen_title: "ยืนยันตัวตนด้วยบริการของสถาบันฯ",
    university_authen_text: "โดยใช้บัญชีผู้ใช้งานของสถาบันฯ",
    guidance: "คำแนะนำ",
    guidance_title: "กรุณาเข้าสู่ระบบด้วย 'เลขที่ใบสมัคร' และ 'รหัสผ่าน' เดียวกันกับข้อมูลที่ใช้กับระบบรับสมัครนักศึกษา ของ สจล.",
    guidance_text: "เมื่อนักศึกษา 'ยืนยันการรายงานตัว' หรือข้อมูลได้รับการตรวจสอบจากเจ้าหน้าที่เรียบร้อยแล้ว ระบบจะทำการ 'ล็อก' ไม่ให้นักศึกษาสามารถแก้ไขข้อมูลได้ ยกเว้นจะมีข้อมูลที่ตรวจไม่ผ่าน (นักศึกษาต้องเข้าระบบเพื่อแก้ไขใหม่)",
  },
  request_password: {
    title: "สร้าง / ลืมรหัสผ่าน",
    text: "กรุณากรอกเลขที่ใบสมัคร และรหัสประจำตัวประชาชน/เลขหนังสือเดินทางที่ใช้ในการสมัคร",
    text2: "กรุณากรอกรหัสผ่านใหม่",
    button: "รีเซ็ตรหัสผ่าน",
    button2: "สร้างรหัสผ่าน",
    home_button: "กลับสู่หน้าเข้าสู่ระบบ",
  },
  info_card: {
    all_7page: "สจล.1 หน้าที่",
    title_page1: "1 / 9 ข้อมูลนักศึกษา",
    title_page2: "2 / 9 ประวัตินักศึกษา",
    title_page3: "3 / 9 ประวัติการศึกษาที่ผ่านมา",
    title_page4: "4 / 9 ข้อมูลบิดา",
    title_page5: "5 / 9 ข้อมูลมารดา",
    title_page6: "6 / 9 ข้อมูลผู้ปกครอง",
    title_page7: "7 / 9 ยินยอมให้ใช้และเปิดเผยข้อมูล",
    title_page8: "8 / 9 รูปภาพนักศึกษา",
    title_page9: "9 / 9 เอกสาร",

    text_info:
      "ข้อมูลที่ให้นักศึกษากรอกใน สจล.1 เป็น 'ข้อมูลรายบุคคลของนักศึกษาในสถาบันอุดมศึกษา' ที่กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม (อว.) กำหนด",

    page2_text:
      "*** กรุณากรอก Email ที่นักศึกษาสามารถใช้งานได้ในปัจจุบัน สำนักบริการคอมพิวเตอร์จะส่ง username/password สำหรับนักศึกษาของสถาบันฯ ไปที่ Email ที่นักศึกษากรอกตามช่วงเวลาที่ประกาศ",
    page3_text: `หากไม่มีชื่อโรงเรียนในตัวเลือก กรุณส่งข้อมูล 'ชื่อ' และ 'ที่อยู่' ของโรงเรียนมาที่อีเมล : admission-reg&#64;kmitl.ac.th`,
    page32_text: `หากไม่มีชื่อมหาวิทยาลัยในตัวเลือก กรุณส่งข้อมูล 'ชื่อ' และ 'ที่อยู่' ของมหาวิทยาลัยมาที่อีเมล : grad-reg&#64;kmitl.ac.th`,

    faculty: "คณะ : ",
    curriculum: "สาขา : ",
    degree: "ระดับ : ",
    name_th: "ชื่อ (ไทย) : ",
    surname_th: "นามสกุล (ไทย) : ",
    gender: "เพศ",
    prename: "คำนำหน้าชื่อ",
    name_en_title: "ชื่อ (อังกฤษ)",
    surname_en_title: "นามสกุล (อังกฤษ)",
    name_en: "ชื่อ (อังกฤษ *ตัวพิมพ์ใหญ่เท่านั้น)",
    surname_en: "นามสกุล (อังกฤษ *ตัวพิมพ์ใหญ่เท่านั้น)",

    thai_citizenID: "รหัสบัตรประจำตัวประชาชน : ",
    thai_citizenID_start_date: "วันที่ออกบัตร",
    thai_citizenID_end_date: "วันที่บัตรหมดอายุ",
    email: "อีเมล",
    mobile: "เบอร์โทรศัพท์",
    birth_date: "วันเกิด",
    nation: "สัญชาติ",
    race: "เชื้อชาติ",
    religion: "ศาสนา",
    talent: "ความสามารถพิเศษ",
    disability: "ความพิการ / บกพร่องทางร่างกาย",
    disabilityPlease:
      "นักศึกษาที่มีความบกพร่องทางร่างกาย โปรดกรอกข้อมูลบัตรประจำตัวผู้พิการ",
    disabilityId: "รหัสบัตรประจำตัวคนพิการ",
    disabilityStartDate: "วันออกบัตรประจำตัวคนพิการ",
    disabilityEndDate: "วันหมดอายุบัตรประจำตัวคนพิการ",
    foreign_student: "นักศึกษาชาวต่างชาติ โปรดกรอกข้อมูล Passport",
    passport_number: "เลขที่หนังสือเดินทาง",
    passport_start_date: "วันที่ออก",
    passport_end_date: "วันที่หมดอายุ",

    address_registration: "ที่อยู่ตามทะเบียนบ้าน",
    address_contact: "ที่อยู่ที่สามารถติดต่อได้",
    address_same: "ตามที่อยู่ทะเบียนบ้าน",
    address_new: "เพิ่มข้อมูลที่อยู่ที่สามารถติดต่อได้",
    house_id: "เลขรหัสประจำบ้าน (ดูในเล่มทะเบียนบ้าน กรอกเฉพาะตัวเลข 11 หลัก)",
    house_number: "บ้านเลขที่",
    village_name: "ชื่อหมู่บ้าน",
    moo: "หมู่ที่",
    soi: "ซอย",
    street: "ถนน",
    province: "จังหวัด",
    district: "อำเภอ",
    sub_district: "ตำบล",
    in_thai: "ในประเทศไทย",
    foreign_country: "ต่างประเทศ",
    country: "ประเทศ",

    school_location: "ที่ตั้งโรงเรียน",
    university_location: "ที่ตั้งมหาวิทยาลัย",
    university_name: "ชื่อมหาวิทยาลัย",
    school_name: "ชื่อโรงเรียน",
    school_type: "ประเภทโรงเรียน",
    education_type: "แผนการศึกษา",
    school_student_id: "เลขที่ประจำตัวนักเรียน หรือ รหัสประจำตัวนักเรียน",
    school_grad_date: "วันที่สำเร็จการศึกษา",
    school_grad_date_detail:
      "*วันที่สำเร็จการศึกษา ต้องตรงกับเอกสารสำเร็จการศึกษาที่ยื่นต่อสถาบันฯ",
    GPA_hint: "GPAX (หากไม่มี GPAX ให้ใส่ค่า 0.00)",
    first_encounter:
      "การเข้าเป็นนักศึกษาของสถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
    first_time: "เข้าเป็นครั้งแรก",
    second_time: "เคยเป็นนักศึกษาของสถาบันฯ มาก่อน",
    old_studentID: "รหัสนักศึกษา (ที่เคยเป็นนักศึกษา สจล.)",
    faculty_college: "คณะ / วิทยาลัย",
    curriculum_name: "หลักสูตร",
    graduated_year: "ปีที่สำเร็จการศึกษา (ค.ศ.)",

    vital_status: "สถานะการมีชีวิตอยู่",
    live: "มีชีวิต",
    passaway: "ถึงแก่กรรม",
    no_information: "ไม่สามารถหาข้อมูลได้",
    occupation: "อาชีพ",
    revenue: "รายได้",
    address: "ที่อยู่",
    parent_address:
      "ที่อยู่ตามทะเบียนบ้าน (เหมือนข้อมูลที่นักศึกษากรอกในหน้าประวัติ)",
    parent_contact:
      "ที่อยู่ที่สามารถติดต่อได้ (เหมือนข้อมูลที่นักศึกษากรอกในหน้าประวัติ)",
    parent_new_address: "เพิ่มที่อยู่ใหม่",
    father: "บิดา",
    mother: "มารดา",
    thai_parent: "คนไทย",
    foreigner_parent: "คนต่างชาติ",
    new_parent: "เพิ่มผู้ปกครองใหม่",
    relative: "ความสัมพันธ์",
    parent_status: "สถานะระหว่างบิดามารดา",

    thai: "ชาวไทย",
    foreigner: "ชาวต่างชาติ",
    fill_thai_citizenID: "เลขบัตรประจำตัวประชาชน",
    fill_passport_number: "เลขพาสปอร์ต",
    textWarning:
      "* ข้อมูลผู้ปกครองต้องระบุตรงกับเอกสาร 'หนังสือยินยอมให้ใช้และเปิดเผยข้อมูล' และ 'หนังสือยืนยันการรายงานตัว'",
    p7_title1: "การยินยอมให้ใช้ข้อมูล",
    p7_text1:
      "ข้าพเจ้ารับทราบและยินยอมให้สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณ ทหารลาดกระบัง (ต่อไปนี้ เรียกว่า “สถาบันฯ”) และ/หรือ บุคคล และ/หรือ นิติบุคคล ที่ได้รับมอบหมาย บันทึกข้อมูล และใช้ข้อมูลของ ข้าพเจ้า (เช่น ข้อมูลที่ข้าพเจ้าให้แก่สถาบันฯ ข้อมูลที่เกิดจากการใช้ ระบบสารสนเทศของสถาบันฯ และข้อมูลอื่น ๆ) ในการทำธุรกรรม และ/หรือ การใช้บริการของข้าพเจ้า เพื่อประโยชน์ในการให้บริการแก่ ข้าพเจ้า และ/หรือ เพื่อประโยชน์อื่นใดที่ข้าพเจ้าได้ให้ความยินยอมไว้ แก่สถาบันฯ รวมถึง เพื่อการวิเคราะห์ข้อมูล เสนอ ให้ ใช้ และ/หรือ ปรับปรุงกระบวนการหรือบริการอื่น นอกจากนี้ สถาบันฯ อาจใช้ ข้อมูลของข้าพเจ้าเพื่อการปฏิบัติตามกฎระเบียบต่าง ๆ ของสถาบันฯ ทั้งนี้ แม้ว่าข้าพเจ้าจะไม่มีสถานภาพนักศึกษาสถาบันฯ แล้วก็ตาม",
    p7_title2: "การยินยอมให้เปิดเผยข้อมูล",
    p7_text2:
      "ข้าพเจ้ามีสิทธิ์ในความเป็นส่วนตัวในข้อมูลของข้าพเจ้า และสถาบันฯ จะไม่เปิดเผยข้อมูลของข้าพเจ้าให้แก่บุคคล และ/หรือ นิติบุคคลอื่น เว้นแต่ในกรณีดังต่อไปนี้",
    p7_text21:
      "การเปิดเผยข้อมูลให้แก่บุคลากรผู้ที่ได้รับอนุญาตของสถาบันฯ ซึ่ง ได้แก่ บุคลากรในส่วนงานของสำนักงานอธิการบดีส่วนงาน วิชาการ และส่วนงานอื่นภายในสถาบันฯ ทั้งนี้ หากไม่ใช่บุคลากร ผู้ได้รับอนุญาตตามที่กล่าวข้างต้น แต่มีความจำเป็นต้องเปิดเผย ข้อมูลส่วนบุคคลของข้าพเจ้า สถาบันฯ จะทำหนังสือขอความ ยินยอมจากข้าพเจ้าเป็นกรณีๆ ไป",
    p7_text22:
      "การเปิดเผยข้อมูลเพื่อให้ข้าพเจ้าสามารถทำธุรกรรม และ/หรือ ใช้ บริการที่ข้าพเจ้าประสงค์ได้ ทั้งนี้ การเปิดเผยข้อมูลดังกล่าวจะไม่ เป็นไปเพื่อแสวงหาผลกำไรจากการใช้ข้อมูลดังกล่าว",
    p7_text23:
      "การเปิดเผยข้อมูลดังกล่าวเป็นไปเพื่อปฏิบัติตามกฎหมาย เพื่อการ สอบสวนหรือการดำเนินการทางกฎหมาย",
    p7_text24:
      "การเปิดเผยข้อมูลดังกล่าวเป็นไปตามกฎหมายหรือตามคำสั่งของ หน่วยงานรัฐ หรือหน่วยงานกำกับดูแลสถาบันฯ ",
    p7_text25:
      "การเปิดเผยข้อมูลให้แก่บุคคล และ/หรือ นิติบุคคล ที่สถาบันฯ ได้รับ ความยินยอมจากข้าพเจ้า ตามวัตถุประสงค์ดังกล่าวข้างต้น จะเป็นไป เพื่อประโยชน์แก่ข้าพเจ้าและไม่เป็นการแสวงหาผลกำไร ทั้งนี้ หากมี ความจำเป็นต้องเปิดเผยข้อมูลของข้าพเจ้าให้แก่บุคคล และ/หรือ นิติ บุคคลที่ไม่ได้กล่าวมาข้างต้น สถาบันฯ จะทำหนังสือขอความยินยอม จากข้าพเจ้าเป็นกรณีๆ ไป",
    p7_textAgree:
      "ข้าพเจ้าตกลงยินยอมให้ใช้และเปิดเผยข้อมูลของข้าพเจ้าตามที่ระบุข้างต้น (กรณีผู้ยินยอมให้ใช้และเปิดเผยข้อมูลเป็นผู้เยาว์ ต้องได้รับความยินยอมจากบิดา มารดา หรือผู้ปกครองตามกฎหมาย)",
  },
  footer: {
    registrar: "สำนักทะเบียนและบริการการศึกษา",
    address1: "เลขที่ 1 ซอยฉลองกรุง 1",
    address2: "แขวงลาดกระบัง เขตลาดกระบัง",
    address3: "กรุงเทพ 10520",
    contact_undergraduate: "ติดต่อ : ระดับปริญญาตรี",
    contact_graduate: "ติดต่อ : ระดับบัณฑิตศึกษา",
    ext: "ต่อ",
  },
  toast: {
    save_successfully: "บันทึกสำเร็จ",
    cannot_save: "บันทึกไม่สำเร็จ",
    create_successfully: "เพิ่มสำเร็จ",
    cannot_create: "เพิ่มไม่สำเร็จ",
    upload_successfully: "อัปโหลดไฟล์สำเร็จ",
    cannot_upload_file: "อัปโหลดไฟล์ไม่สำเร็จ",
    delete_successfully: "ลบสำเร็จ",
    cannot_delete: "ลบไม่สำเร็จ",
    edit_successfully: "แก้ไขสำเร็จ",
    cannot_edit: "แก้ไขไม่สำเร็จ",
    mail_sent: "ส่งอีเมลแล้ว",
    mail_sent_to: "ส่งอีเมลแล้ว กรุณาตรวจสอบที่",
  },
  config: {
    addnew: "เพิ่มใหม่",
    edit: "แก้ไข",
    delete: "ลบ",
    number: "#",
    save: "บันทึก",
    cancel: "ยกเลิก",
  },
  config_year: {
    config_year: "ตั้งค่าปีการศึกษาที่รับเข้า",
    admit_year: "ปีรับเข้าศึกษา",
    admit_semester: "เทอมรับเข้าศึกษา",
    level_id: "ระดับ",
    start_datetime_system: "วันที่เริ่มใช้ปีการศึกษานี้",
    admit_date: "วันที่เข้าศึกษา",
  },
  config_round: {
    config_round: "ตั้งค่ารอบการรายงานตัว",
    config_year: "เทอมรับเข้าศึกษา/ปีรับเข้าศึกษา",
    round_name_th: "ชื่อรอบภาษาไทย",
    round_name_en: "ชื่อรอบภาษาอังกฤษ",
    round_start_datetime: "วันเริ่มเปิดรอบรายงานตัว",
    round_end_datetime: "วันสุดท้ายของรอบรายงานตัว",
  },
  config_document: {
    config_document: "ตั้งค่าเอกสาร",
    level_id: "ระดับ",
    document_type_name_th: "ชื่อเอกสารภาษาไทย",
    document_type_name_en: "ชื่อเอกสารภาษาอังกฤษ",
    required: "จำเป็น",
    order: "ลำดับ",
    example_filepath: "ไฟล์พาร์ทตัวอย่างเอกสาร",
    form_filepath: "ไฟล์พาร์ทฟอร์มเอกสาร",
    enabled: "เปิดใช้งาน",
  },
  officer: {
    find_edit_data: "ค้นหา / แก้ไขข้อมูลเริ่มต้น",
    main_officer: "ตรวจรายงานตัว / สวมสิทธิ์",
    kmitl1: "เรียกดู สจล.1",
    export_data: "นำเข้านักศึกษาสู่ระบบหลัก",
    check: "ระดับปริญญาตรี",
    check_grad: "ระดับบัณฑิตศึกษา",
  },
  main: {
    status: "สถานะการรายงานตัวออนไลน์",
    comment: "มีสิ่งที่ต้องแก้ไข ดังนี้",
    has_comment_for_photo: "ข้อ 8 : ",
    has_comment_for_document: "ข้อ 9 มีแก้ไขเอกสาร ดูรายละเอียด",
    step_of_marticulation: "ขั้นตอน",
    step_of_marticulation_detail:
      'สถานะการรายงานตัวจะเป็น "รายงานตัวสำเร็จ" ก็ต่อเมื่อ',
    step_of_marticulation_1: "1) กรอกข้อมูล สจล.1 ให้ครบทั้ง 9 ข้อ",
    step_of_marticulation_2: '2) คลิกปุ่ม "ส่งข้อมูลการรายงานตัว"',
    step_of_marticulation_3: "3) รอผลการตรวจสอบจากเจ้าหน้าที่",
    step_of_marticulation_4:
      '4) หากผลตรวจ "ตรวจเอกสารไม่ผ่าน" ให้แก้ไขตามรายการ "สิ่งที่ต้องแก้ไข" และส่งข้อมูลการรายงานตัวตามข้อ 2) อีกครั้ง',
    step_of_marticulation_5:
      '5) หากผลตรวจเรียบร้อย สถานะจะแสดงเป็น "รายงานตัวสำเร็จ"',
    confirm_commit: "ส่งข้อมูลการรายงานตัว",
    remark: "หมายเหตุ",
    remark_1:
      '- หลังจากทำรายการข้อมูลครบทั้ง 9 ข้อ จึงจะสามารถกดปุ่ม "ส่งข้อมูลการรายงานตัว" ได้',
    remark_2:
      '- หลังจากทำการกด "ส่งข้อมูลการรายงานตัว" รายการข้อมูลทั้ง 9 ข้อจะถูกล็อกไม่ให้สามารถแก้ไขได้',
    remark_3:
      '- หากสถานะการรายงานตัว "ตรวจเอกสารไม่ผ่าน" กรุณากรอกหรืออัปโหลดใหม่ตามรายการ "สิ่งที่ต้องแก้ไข" ',
    page1: "1 : ข้อมูลนักศึกษา",
    page2: "2 : ประวัตินักศึกษา",
    page3: "3 : ประวัติการศึกษาที่ผ่านมา",
    page4: "4 : ข้อมูลบิดา",
    page5: "5 : ข้อมูลมารดา",
    page6: "6 : ข้อมูลผู้ปกครอง",
    page7: "7 : ยินยอมให้ใช้และเปิดเผยข้อมูล",
    page8: "8 : รูปภาพนักศึกษา",
    page9: "9 : เอกสาร",
    round_locked: 'นักศึกษาไม่อยู่ในช่วงการรายงานตัว โปรดตรวจสอบช่วงเวลาการรายงานตัวในเมนู "สิ่งที่ควรทราบ"',
  },
  timeline: {
    symbol: "สัญลักษณ์",
    not_complete: "ยังไม่กรอกข้อมูล",
    complete: "กรอกข้อมูลแล้ว",
    can_not_edit: "ปิดการแก้ไขข้อมูล",
    can_edit: "เปิดให้แก้ไขข้อมูล",
  },
  upload: {
    choose_files: "เลือกไฟล์",
    upload: "อัปโหลด",
    clear: "ล้างค่า",
    drag_and_drop: "ลากและวางไฟล์ที่นี่",
    support_file_types: "ประเภทไฟล์ที่รองรับ",
    max_file_size: "ขนาดต่อไฟล์สูงสุด",
    max_num_files: "จำนวนไฟล์สูงสุด",
    pending: "รอดำเนินการ",
    alert: "แจ้งเตือน",
    alert_text: 'อย่าลืมกดปุ่ม "อัปโหลด"',
    close: "ปิด",
    file: "ไฟล์",
    view_file: "เรียกดูไฟล์",
  },
  upload_photo: {
    status: "สถานะ",
    uploaded: "อัปโหลดรูปภาพนักศึกษาแล้ว",
    not_upload: "ยังไม่ได้อัปโหลดรูปภาพนักศึกษา",
    correction_details: "รายละเอียดการแก้ไข",
    example: "ตัวอย่าง",
  },
  upload_doc: {
    status: "สถานะ",
    uploaded: "อัปโหลดเอกสารครบแล้ว",
    not_upload: "ยังอัปโหลดเอกสารไม่ครบ",
    required: "จำเป็น",
    optional: "ถ้ามี",
    correction_details: "รายละเอียดการแก้ไข",
    example_file: "ไฟล์ตัวอย่าง",
    download_form: "ดาวน์โหลดฟอร์ม",
    delete_all_files: "ลบไฟล์ทั้งหมด",
  },
  questionnaire: {
    title: "ประเมินแบบสอบถามความพึงพอใจ ระบบรายงานตัวออนไลน์",
    general_information: "ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม",
    Q0_1: "นักศึกษาใช้อุปกรณ์ใดเข้าใช้งานระบบ",
    Q0_2: "นักศึกษาทราบข่าวการรายงานตัวออนไลน์จาก",

    level_satisfaction_user: "ระดับความพึงพอใจของผู้รับบริการ",
    please_fill_in_truth:
      "*** กรุณากรอกตามความจริง เพื่อใช้เป็นข้อมูลในการปรับปรุงระบบและบริการ ***",
    header_table1: "คุณลักษณะ",
    header_table2: "ระดับ (1:พึงพอใจน้อยมาก ถึง 5:พึงพอใจมากที่สุด)",
    header_table2_hint: "(โปรดให้ดาวตามระดับความพึงพอใจของท่าน)",
    news_source_specify: "โปรดระบุแหล่งข่าว",
    Q1: "1. ด้านกระบวนการ (Process)",
    Q1_1: "1.1 ความง่ายในการใช้งานระบบ (User Friendly)",
    Q1_2: "1.2 ความเหมาะสมของขั้นตอน การรายงานตัว",
    Q1_3: "1.3 ความเหมาะสมของขั้นตอน การบันทึกข้อมูลพื้นฐาน",
    Q1_4: "1.4 ความง่ายในการกรอกข้อมูล ที่มีความเชื่อมโยงสัมพันธ์กัน",
    Q1_5: "1.5 ความสะดวกในการอัปโหลด ภาพหรือเอกสารประกอบการรายงานตัว",
    Q2: "2. ด้านคุณภาพของเนื้อหา (Content)",
    Q2_1: "2.1 ความสะดวก ในการเชื่อมโยงข้อมูลภายในเว็บไซต์",
    Q2_2: "2.2 ความรวดเร็ว ในการเข้าถึงเว็บไซต์",
    Q2_3: "2.3 ความเหมาะสม ของข้อมูลภายในเว็บไซต์",
    Q2_4: "2.4 ความถูกต้อง ครบถ้วนของข้อมูล",
    Q2_5: "2.5 ความเหมาะสม ในการประชาสัมพันธ์ขั้นตอนการรายงานตัว",
    Q3: "3. ด้านการออกแบบและการจัดรูปแบบ (Design)",
    Q3_1: "3.1 ความสวยงาม ความทันสมัย น่าสนใจของหน้าเว็บไซต์",
    Q3_2: "3.2 การจัดรูปแบบ ในเว็บไซต์ให้ง่ายต่อการอ่านและการใช้งาน",
    Q3_3: "3.3 ขนาดและรูปแบบตัวอักษร อ่านได้ง่ายและสบายตา",
    Q3_4: "3.4 ความเร็ว ในการแสดงภาพ ตัวอักษร และข้อมูลต่าง ๆ",
    Q3_5: "3.5 ท่านคิดว่าระบบการรายงานตัวครั้งนี้ สมบูรณ์เพียงใด",

    additional_info: "ข้อมูลเพิ่มเติม",
    additional_1: "แนวทางการปรับปรุงโปรแกรม / พัฒนาระบบ / สิ่งที่คาดหวัง",
    additional_2: "ข้อเสนอแนะเพิ่มเติม / ข้อเสนอแนะอื่นๆ",
    please_rate: "โปรดให้คะแนน",
  },
  generate: {
    title: "สร้างรหัสนักศึกษา",
    topic: "เลือกต้นทาง",
    level: "ระดับชั้น",
    year: "ปีการศึกษา",
    mode: "โหมด",
    confirm: "ยืนยัน",
    data: "ดาวน์โหลดข้อมูล",
  },
  insert: {
    title: "นำเข้าผู้สมัครสู่ระบบรายงานตัว",
    sub_title: "เพิ่มผู้สมัครจาก ระบบรับสมัคร เข้า ระบบรายงานตัว แบบรายบุคคลหรือทั้งหมด",
    level: "ระดับ",
    year: "ปีการศึกษา",
    semester: "เทอม",
    apply_id: "เลขที่ใบสมัคร",
    search: "ค้นหา",
    name: "ชื่อ",
    surname: "นามสกุล",
    add_student: "เพิ่มนักศึกษา",
    reset: "ล้างค่า",
  },
  export: {
    title: "นำเข้าผู้รายงานตัวสู่ระบบหลัก",
    sub_title: "เพิ่มนักศึกษาจาก ระบบรายงานตัว เข้า ระบบหลักสำนักทะเบียน แบบรายบุคคลหรือทั้งหมด",
    level: "ระดับ",
    year: "ปีการศึกษา",
    semester: "เทอม",
    student_id: "รหัสนักศึกษา",
    search: "ค้นหา",
    name: "ชื่อ",
    surname: "นามสกุล",
    add_student: "เพิ่มนักศึกษา",
    reset: "ล้างค่า",
  },
};
